import { vgaPalette, STARTING_COLOR } from './palette.js';

export class Tools {
  constructor() {
    this.activeColor = STARTING_COLOR;
    this.activeTool = 'brush';
    this.toolbox = document.getElementById('toolbox');
    this.activeColorLine = document.getElementById('activeColor');
  }

  render() {
    this.renderTools();
    this.updateActiveColorLine();
  }

  renderTools() {
    this.toolbox.innerHTML = '';
    ['brush', 'eraser', 'dropper'].forEach(tool => {
      const button = document.createElement('button');
      button.textContent = tool;
      button.className = 'tool';
      button.setAttribute('aria-label', `${tool} tool`);
      button.style.backgroundColor = this.activeTool === tool ? vgaPalette[this.activeColor] : '';
      button.addEventListener('click', () => {
        this.activeTool = tool;
        this.renderTools();
      });
      this.toolbox.appendChild(button);
    });
  }

  updateActiveColorLine() {
    this.activeColorLine.style.backgroundColor = vgaPalette[this.activeColor];
  }

  setActiveColor(colorIndex) {
    this.activeColor = colorIndex;
    this.updateActiveColorLine();
    this.renderTools();
  }

  getActiveColor() {
    return this.activeColor;
  }

  getActiveTool() {
    return this.activeTool;
  }

  reset() {
    this.activeColor = STARTING_COLOR;
    this.activeTool = 'brush';
    this.updateActiveColorLine();
    this.renderTools();
  }
} 